import { Injectable } from '@angular/core';
import { Observable, OperatorFunction, Subject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

interface IEvent {
  key: any;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private _store: Map<string, any>;
  private _eventBus: Subject<IEvent>;

  constructor() {
    this._eventBus = new Subject<IEvent>();
    this._store = new Map();
  }

  fire(key: string, data: any): void {
    this._eventBus.next({ key, data });
    this._store.set(key, data);
  }

  on<T>(key: string): Observable<T> {
    return this._eventBus.asObservable().pipe(
      this.initialValue(this._store.has(key), { key, data: this._store.get(key) } as IEvent),
      filter((event: any) => event.key === key),
      map((event: any) => event.data as T)
    );
  }

  private initialValue<T>(condition: boolean, value: T): OperatorFunction<T, T> {
    return (source: Observable<T>): Observable<T> => (condition ? source.pipe(startWith(value)) : source);
  }

  clearEvents(keys: string[]) {
    keys.forEach((key) => {
      this._store.delete(key);
    });
  }
}
